
@if (contentInfo) {
  <app-object-content-list [contentInfo]="contentInfo"
                           (objectRefresh)="onObjectRefresh($event)">
  </app-object-content-list>
}
